import { render, staticRenderFns } from "./AdminCallLogsTable.vue?vue&type=template&id=3a6c9d56&scoped=true"
import script from "./AdminCallLogsTable.vue?vue&type=script&lang=js"
export * from "./AdminCallLogsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminCallLogsTable.vue?vue&type=style&index=0&id=3a6c9d56&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c9d56",
  null
  
)

export default component.exports